var React = require('react');

function PlayBtnInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48.847 24.4235C48.847 37.9122 37.9122 48.847 24.4235 48.847C10.9348 48.847 0 37.9122 0 24.4235C0 10.9348 10.9348 0 24.4235 0C37.9122 0 48.847 10.9348 48.847 24.4235Z","fill":"white","key":0}),React.createElement("path",{"d":"M19.177 15.5961V32.8609C19.177 34.0837 20.5915 34.7636 21.5464 33.9997L32.3369 25.3673C33.0667 24.7835 33.0667 23.6735 32.3369 23.0897L21.5464 14.4573C20.5915 13.6934 19.177 14.3733 19.177 15.5961Z","fill":"#1F212D","key":1})]);
}

PlayBtnInline.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49","fill":"none"};

module.exports = PlayBtnInline;

PlayBtnInline.default = PlayBtnInline;
